import { useEffect, useRef } from "react";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import { useCart } from "../components/contexts/CartContext";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ExpressCheckoutAddressPageForm from "../components/shopPartials/ExpressCheckoutAddressPageForm";
import { motion } from "framer-motion";

const ExpressAddressPage = () => {
  const { cart, loading } = useCart();
  const { discountCoupons } = useGeneral();

  const addressRef = useRef(null);

  // ✅ Scroll to address section on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      if (addressRef.current) {
        addressRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300); // small delay ensures DOM ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <>

      <PageWrapper loading={loading} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        {loading && <FullScreenLoading />}
        <BodyWrapper loading={loading}>
          
          <motion.div
            ref={addressRef}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <ExpressCheckoutAddressPageForm />
          </motion.div>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default ExpressAddressPage;
